/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";

const OnOffContainer = styled.div<{ state: boolean }>`
    display: flex;
    border-radius: 30px;
    height: 30px;
    width: 50px;
    background-color: ${(props) => (props.state ? theme.primary50 : "rgba(255, 62, 62, 0.10)")};
    color: ${(props) => (props.state ? theme.primary500 : "#FF3E3E")};
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    justify-content: center;
`;

export const OnOffTag = ({ state }: { state: boolean }) => {
    return (
        <OnOffContainer state={state}>
            <p>{state ? "On" : "Off"}</p>
        </OnOffContainer>
    );
};
